import { ROUTES } from './Lib/constants';

// ? prod server url
const baseUrl = 'https://apiv2.appraiseall.net';
// ? staging server url
// const baseUrl = 'http://18.117.180.109:7001';
// ? local server url
// const baseUrl = 'http://localhost:7001';

let gpsSocketUrl = process.env.REACT_APP_GPS_URL;
gpsSocketUrl = 'http://127.0.0.1:4583';
export const BASE_URL = baseUrl;
export const SOCKET_BASE_URL = baseUrl;
export const GPS_SOCKET_URL = gpsSocketUrl;
export const SESSION_CHECK = process.env.REACT_APP_SESSION_CHECK;
export const VERSION = 'v-2.3.4 ';
export const SERVER_VERSION = 10; 
export const MODE = process.env.REACT_APP_MODE;
export const LOG_ENABLED = process.env.REACT_APP_LOG_ENABLE;
export const LANDING_VIEW = ROUTES.WelcomeSA.name;
export const currency = {
  code: 'INR',
  sign: ' ₹',
  name: 'rupay',
};
  